import { Column, Row } from 'app/design/primitives/box';
import type { ButtonProps } from 'app/design/primitives/button';
import { Button, PressableType } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import type { ReactNode } from 'react';
const theme = createDSTheme();

const RenderedButton1 = ({
  color,
  emoji,
  text,
  chevron,
  onPress,
  testID,
}: {
  color: { default: string; light: string };
  emoji: string;
  text: string;
  chevron: boolean;
  onPress: ButtonProps['onPress'];
  testID?: string;
}) => {
  return (
    <Button
      height={76}
      onPress={onPress}
      testID={testID}
      pressableType={PressableType.GestureHandler}
      style={{ borderRadius: 36, paddingHorizontal: 15, paddingVertical: 13 }}
      variant="secondaryLight"
    >
      <Row alignItems="center" gap="spacing.general.x4" flex={1}>
        <Row alignItems="center" style={{ backgroundColor: color.light, height: 48, width: 48, borderRadius: 24 }}>
          <Column alignItems="center" flexGrow={1}>
            <Text
              fontSize={23}
              fontWeight="700"
              style={{
                boxShadow: `0px 3px 3px ${color.default}`,
              }}
            >
              {emoji}
            </Text>
          </Column>
        </Row>
        <Text fontWeight="700" style={{ flexGrow: 1 }} variant="bodyBase">
          {text}
        </Text>
        {chevron ? (
          <IconChevronRight
            strokeWidth={ICON_STROKE_WIDTH}
            size={48}
            color={theme.colors['surface.inverse.tertiary-neutral']}
          />
        ) : null}
      </Row>
    </Button>
  );
};

const RenderedButton2 = ({
  text,
  emoji,
  leading,
  variant,
  onPress,
  testID,
}: {
  text: string;
  emoji?: string;
  leading?: ReactNode;
  variant: ButtonProps['variant'];
  onPress: ButtonProps['onPress'];
  testID?: string;
}) => {
  return (
    <Button
      height={60}
      onPress={onPress}
      testID={testID}
      pressableType={PressableType.GestureHandler}
      style={{
        borderRadius: 30,
        paddingVertical: 10,
        paddingHorizontal: 8,
        borderColor: variant === 'primary' ? 'transparent' : theme.colors['border.secondary'],
        borderWidth: 1,
      }}
      variant={variant}
    >
      <Row alignItems="center" flex={1} gap="spacing.general.x4">
        <Row
          alignItems="center"
          style={{
            backgroundColor: variant === 'primary' ? '#E7F6ED1A' : '#E7F6ED',
            height: 48,
            width: 48,
            borderRadius: 24,
            overflow: 'hidden',
          }}
        >
          {leading ?? (
            <Column alignItems="center" flexGrow={1}>
              <Text fontSize={23} fontWeight="700">
                {emoji}
              </Text>
            </Column>
          )}
        </Row>
        <Text
          color={variant === 'primary' ? 'surface.default' : 'text.primary'}
          ellipsizeMode="tail"
          flex={1}
          flexShrink={1}
          fontWeight="700"
          numberOfLines={1}
          style={{ minWidth: 0 }}
          variant="bodyBase"
        >
          {text}
        </Text>
      </Row>
    </Button>
  );
};

export { RenderedButton1, RenderedButton2 };
